import styled from 'styled-components/macro';

export const Container = styled.div`
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: var(--main-bg-color);
  color: var(--primary-text-color);
  display: flex;
  justify-content: center;
  align-items: center;
`;
